<template>
    <div class="activity-box">
        <!-- 面包屑导航 -->
        <div class="bread-bar">
            <span class="cup" @click="handlebreadLink('/index/index')">{{ $t('首页') }}</span><span>/</span>
            <span class="link">{{ $t('活动') }}</span>
        </div>
        <div class="banners-box df">
            <div class="left-box fn">
                <activeSwiper></activeSwiper>
            </div>
            <div class="right-box f1">
                <activeDate />
            </div>
        </div>

        <!-- 活动列表 -->
        <div class="active-list">
            <div class="titles">{{ $t('活动列表') }}</div>

            <div class="search-box df aic jcsb">
                <el-radio-group v-model="FormData.sort_method" @change="handleHotLike">
                    <el-radio :label="0" value="0">{{ $t('最新') }}</el-radio>
                    <el-radio :label="10" value="10">{{ $t('最热') }}</el-radio>
                </el-radio-group>
                <div class="btns df aic">
                    <div class="ipt-box">
                        <el-form class="df" @submit.native.prevent="handleSubsearch">
                            <el-input type="text" v-model="FormData.search_key" :placeholder="$t('请输入活动名称')"></el-input>
                        <el-button type="text" @click="handleSubsearch"><span
                                class="iconfont">&#xe8b9;</span></el-button>
                        </el-form>
                        
                    </div>
                    <el-button type="text" class="more-btn" @click="flogshowcity = !flogshowcity">{{ $t('更多筛选')
                        }}</el-button>
                </div>
            </div>

            <div class="search-contents" :class="{ 'showbox': flogshowcity }">


                <div class="search-list" v-if="cityList.region_list">
                    <el-radio-group v-model="FormData.act_region" @change="handleRegion">
                        <el-radio :label="0" :value="0" :key="-1">
                            {{ $t('全部') }}
                        </el-radio>
                        <el-radio :label="items1.value" :value="items1.value" :key="index1"
                            v-for="(items1, index1) in cityList.region_list">
                            {{ items1.label }}
                        </el-radio>

                    </el-radio-group>
                </div>
                <div class="search-list" v-if="cityList.country_list">
                    <el-radio-group v-model="FormData.act_country" @change="handleCountry">
                        <el-radio :label="0" :value="0" :key="-1">
                            {{ $t('全部') }}
                        </el-radio>
                        <el-radio :label="items1.value" :value="items1.value" :key="index1"
                            v-for="(items1, index1) in cityList.country_list">
                            {{ items1.label }}
                        </el-radio>
                    </el-radio-group>
                </div>
                <div class="search-list" v-if="cityList.province_list">
                    <el-radio-group v-model="FormData.act_province" @change="handleProvince">
                        <el-radio :label="0" :value="0" :key="-1">
                            {{ $t('全部') }}
                        </el-radio>
                        <el-radio :label="items1.value" :value="items1.value" :key="index1"
                            v-for="(items1, index1) in cityList.province_list">
                            {{ items1.label }}
                        </el-radio>
                    </el-radio-group>
                </div>
                <div class="search-list" v-if="cityList.city_list">
                    <el-radio-group v-model="FormData.act_city" @change="handleCity">
                        <el-radio :label="0" :value="0" :key="-1">
                            {{ $t('全部') }}
                        </el-radio>
                        <el-radio :label="items1.value" :value="items1.value" :key="index1"
                            v-for="(items1, index1) in cityList.city_list">
                            {{ items1.label }}
                        </el-radio>
                    </el-radio-group>
                </div>

                <!-- 行业 -->

                <div class="search-list" v-if="act_ind_list.length">
                    <el-radio-group v-model="FormData.act_ind_sec" @change="handleCity">
                        <el-radio :label="0" :value="0" :key="-1">
                            {{ $t('全部') }}
                        </el-radio>
                        <el-radio :label="items1.tais_id" :value="items1.tais_id" :key="index1"
                            v-for="(items1, index1) in act_ind_list">
                            {{ items1.tais_name }}
                        </el-radio>
                    </el-radio-group>
                </div>

            </div>

            <div class="active-listcontent df fww">

                <template v-if="dataList && dataList.length > 0">
                    <div class="list" v-for="(item, index) in dataList" @click="handleLink(item)">
                        <div class="img-box">
                            <el-image :src="item.ta_thumb" fit="cover">
                                <div slot="error" class="image-slot">
                                    <img src="@/assets/images/news-default.png" alt="">
                                </div>
                            </el-image>

                        </div>
                        <div class="list-box">
                            <div class="title mic-semblod one-text">{{ item.ta_title }}</div>
                            <div class="desc one-text" style="white-space: nowrap;">{{ item.ta_desc }}</div>
                            <div class="date-box df aic jcsb">
                                <div class="le over-h">
                                    <div class="address one-text">
                                        <span class="iconfont">&#xe61f;</span>{{ item.ta_city_text }}
                                    </div>
                                    <div class="date"><span class="iconfont">&#xe602;</span>{{ item.ta_start_time }}</div>
                                </div>
                              <div class="ri fn">
                                <el-button type="success" class="end" v-if="item.is_sign_up == 10">
                                  {{ $t('活动已结束') }}
                                </el-button>
                                <el-button type="success" v-else-if="item.is_sign_up == 20">
                                  {{ $t('即将举行') }}
                                </el-button>
                                <el-button type="success" v-else-if="item.is_sign_up == 30">
                                  {{ $t('活动报名中') }}
                                </el-button>
                                <el-button type="success" v-else-if="item.is_sign_up == 40">
                                  {{ $t('活动进行中') }}
                                </el-button>
                              </div>

                            </div>
                        </div>
                    </div>
                </template>

                <div class="no-data" v-else>
                    <img src="@/assets/images/empty_data.png" alt="">
                    <p>{{ $t('暂无数据') }}</p>
                </div>

            </div>

            <div class="pageing-box df aic jcc">

                <el-button type="text" class="add-btn" @click="handlePages(1)">{{ $t('回首页') }}</el-button>
                <el-pagination :current-page="pagination.page" :page-size="12" :total="pagination.total"
                    layout=" prev, pager, next,slot" @current-change="handleCurrent">


                    <span class="jump-text">{{ $t('跳转') }}</span>
                    <el-input-number :controls="false" v-model="jumpIndex" :min="1" :max="totalPages"
                        @change="handleJump" size="small" class="jump-ipt" style="width: 28px; margin-left: 8px;" />

                </el-pagination>
                <el-button type="text" class="add-btn ml-11" @click="handlePages(totalPages)">{{$t('去尾页')}}</el-button>
            </div>
        </div>
    </div>
</template>

<script>
// 日历
import activeDate from "./components/date.vue";
// swiper
import activeSwiper from "./components/swiperPage.vue";
import { mapGetters, mapActions } from 'vuex';
// 接口
import { getactivityGetArea, getactivityList } from "@api/active";
import {getActivityCommonData} from "../../api/active";
export default {
    computed: {
        // ...mapGetters() // 使用命名空间访问 home 模块的 datalist getter

        ...mapGetters('home', ['datalist'])

    },
    components: {
        activeDate, activeSwiper
    },

    data() {
        return {
            // 是否暂时区域筛选
            flogshowcity: false,

            hotList: null,

            pagination: {
                page: 1,
                total: 0,

            },

            totalPages: 0, //总页数
            jumpIndex: '',

            dataList: [],
            act_ind_list: [],

            FormData: {
                sort_method: 0,
                search_key: '',
                act_region: 0,
                act_country: 0,
                act_province: 0,
                act_city: 0,
                act_ind_sec: 0,//行业
            },

            cityList: {
                region_list: [],
                country_list: [],
                province_list: [],
                city_list: [],
            },



        }
    },
    mounted() {
        // 设置默认的顶部菜单背景色
        this.$bus.$emit('changeNavbg', 'rgba(255, 255, 255, 1);');

        this.getData();
        this.getActivityCommonData();

        this.getcitytArea();


    },

    methods: {

        handlePages(index) {
            this.pagination.page = index;
            this.getData();
        },

        // 跳转
        handleJump() {
            this.pagination.page = this.jumpIndex;
            this.getData();
        },

        // 面包屑导航跳转
        handlebreadLink(path) {
            let str = '/cn';
            let Language = localStorage.getItem('currentLanguage');  //获取本地语言
            if (Language && Language != 'zh') {
                str = '/' + Language;
            }
            this.$router.push(str + path); // 使用编程式导航跳转到 About 页面
        },
        // 跳转详情
        handleLink(item) {
            let str = '/cn';
            let Language = localStorage.getItem('currentLanguage');  //获取本地语言
            if (Language && Language != 'zh') {
                str = '/' + Language;
            }
            let target={}
            // 判断是否是精英赛
            if(item.ta_kind==30){
                target = this.$router.resolve(str + '/challenge/info/' + item.ta_id)
            }else{
                target = this.$router.resolve(str + '/activity/info/' + item.ta_id)
            }
            window.open(target.href, '_blank');
        },

        handleCity() {
            this.getData();
        },
        // 选择省份
        handleProvince() {
            let areaObj = {
                act_region: this.FormData.act_region,
                act_country: this.FormData.act_country,
                act_province: this.FormData.act_province,
                act_city: 0,
            }
            this.FormData.act_city = 0;
            this.getData();
            this.getcitytArea(areaObj);
        },
        // 选择国家
        handleCountry() {
            let areaObj = {
                act_region: this.FormData.act_region,
                act_country: this.FormData.act_country,
                act_province: 0,
                act_city: 0,
            }

            this.FormData.act_province = 0;
            this.FormData.act_city = 0;
            this.getData();
            this.getcitytArea(areaObj);
        },

        // 选择洲
        handleRegion() {
            let areaObj = {
                act_region: this.FormData.act_region,
                act_country: 0,
                act_province: 0,
                act_city: 0,
            }

            this.FormData.act_country = 0;
            this.FormData.act_province = 0;
            this.FormData.act_city = 0;

            this.getData();

            this.getcitytArea(areaObj);

        },

        // 分页改变
        handleCurrent(val) {
            this.pagination.page = val;
            this.getData();
        },

        // 最新,最热
        handleHotLike() {
            this.getData();
        },

        // 搜索
        handleSubsearch() {
            this.getData();
        },

        // 初始化获取数据
        async getData() {
            const res = await getactivityList({ ...this.FormData, page: this.pagination.page });
            if (res.status == 200) {
                this.pagination.total = res.data.act_list.total;
                this.totalPages = Math.ceil(this.pagination.total / 12);
                this.dataList = res.data.act_list.data;
            }
        },
      async getActivityCommonData() {
            const res = await getActivityCommonData();
            if (res.status == 200) {
                this.act_ind_list = res.data.act_ind_sec_list;
            }
        },


        // 区域筛选
        async getcitytArea(obj = {}) {


            let res = await getactivityGetArea({ ...obj });
            if (res.status == 200) {
                this.cityList = res.data;
            }

        }

    }
}
</script>

<style lang="scss" scoped>
.el-pagination .jump-text {
    min-width: 10px;
}

.jump-text {
    min-width: 10px;
    color: rgba(0, 0, 0, 0.9);
    font-weight: 400;
    font-family: "harmonyos";
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
}

.el-pager li {
    min-width: 28px;
}

.add-btn {
    color: rgba(0, 0, 0, 0.9);
    font-family: "harmonyos";
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;

    &:hover {
        color: #B7251E;
    }
}

.jump-ipt {
    box-sizing: border-box;
    /* Light/comp_divider */
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    /* bg/color-bg-1 */
    background: rgb(255, 255, 255);
    width: 28px;
    height: 28px;
}

::v-deep() {
    .el-pagination .jump-text {
        min-width: 10px;
    }

    .el-pager li {
        min-width: 28px;
        margin: 0 4px;
        border-radius: 8px;

        &:hover {
            background: rgb(255, 243, 242);
        }
    }

    .el-pagination .btn-next,
    .el-pagination .btn-prev {
        width: 28px;
        height: 28px;
        border-radius: 8px;
        padding: 0;
        min-width: 28px;
        margin-right: 8px;

        &:hover {
            background: rgb(255, 243, 242);
        }
    }

    .jump-ipt {
        .el-input__inner {
            padding: 0;
            height: 26px;
            line-height: 26px;
            border: none;
            position: relative;
            top: -2px;
            background-color: transparent;
        }
    }

    // .el-input-number.is-without-controls .el-input__inner {
    //     padding: 0;
    //     height: 28px;
    //     border: none;
    // }
}

.no-data {
    width: 100%;
    text-align: center;
    padding: 80px 0;

    p {
        color: rgb(119, 119, 119);
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        margin-top: 7px;
    }
}

.activity-box {
    padding: 40px 80px 0;
    margin-top: 60px;

    .bread-bar {
        max-width: 1752px;
        margin: 0 auto;
        font-size: 18px;
        font-weight: 400;
        line-height: 24px;
        color: #939393;

        span {
            margin-right: 4px;
        }

        .link {
            color: #191919;
        }
    }
}

.banners-box {
    padding-top: 20px;
    max-width: 1752px;
    margin: 0 auto;

    .left-box {
        min-width: 425px;
        width: 24.15%;
        height: 528px;
        border-radius: 12px;
        overflow: hidden;
    }

    .right-box {
        width: calc(100% - 445px);
        border: 1px solid rgb(236, 236, 236);
        border-radius: 12px;
        box-shadow: 0px 2px 24px 0px rgba(0, 0, 0, 0.12);
        height: 528px;
        margin-left: 20px;
    }
}

.search-box {
    margin-top: 20px;

    ::v-deep() {
        .el-radio:hover {
            .el-radio__input {
                &::after {
                    background-color: #F5F5F5;
                }
            }
        }

        .el-radio__input {
            position: relative;

            &::after {
                content: "";
                display: block;
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background-color: #fff;
                position: absolute;
                left: -2px;
                top: -2px;
                z-index: -1;
            }

        }

        .el-radio__inner {
            width: 16px;
            height: 16px;
            border: 1px solid rgba(0, 0, 0, 0.4);

        }

        .el-radio__label {
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            color: rgb(25, 25, 25);
            padding-left: 6px;
        }
    }

    .btns {
        .ipt-box {
            width: 360px;
            height: 36px;
            border: 1px solid rgba(223, 223, 223, 0.5);
            border-radius: 20px;
            background: rgb(245, 246, 248);
            overflow: hidden;
            padding-right: 16px;

            ::v-deep() {
                .el-input__inner {
                    background-color: transparent;
                    border: none;
                    line-height: 34px;
                    height: 34px;
                    padding: 0 16px;

                    &::placeholder {
                        color: #AEAEAE;
                    }
                }

                .el-button--text {
                    padding: 0;
                    color: #AEAEAE;
                }
            }

            margin-right: 40px;
        }

        .more-btn {
            &.el-button--text {
                color: rgb(25, 25, 25);
                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
                padding: 0;
            }
            &:hover{
                color:#b7251e;
            }
        }

    }
}

.active-list {
    padding-top: 40px;
    max-width: 1752px;
    margin: 0 auto;

    .titles {
        color: rgb(25, 25, 25);
        font-size: 32px;
        font-weight: 400;
        line-height: 48px;
    }
}

.search-contents {
    height: 0px;
    overflow: hidden;

    &.showbox {
        height: max-content;
    }

    .search-list:first-child {
        margin-top: 14px;
    }

    .search-list {
        margin-top: 9px;

        ::v-deep() {
            .el-radio {
                min-width: 86px;
                margin-right: 16px;
                margin-bottom: 12px;
            }

            .el-radio__inner {
                width: 16.67px;
                height: 16.67px;
                border: 1px solid rgba(0, 0, 0, 0.4);
            }

            .el-radio__label {
                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
                color: rgb(25, 25, 25);
                padding-left: 1px;
            }
        }
    }
}

.active-listcontent {
    padding-bottom: 40px;

    .list {
        width: calc(33.33% - 13.33px);
        height: 430px;
        border-radius: 6px;
        box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
        background: rgb(255, 255, 255);
        margin-top: 20px;
        overflow: hidden;
        cursor: pointer;

        &:hover {
            // ::v-deep() {
            //     .el-image {
            //         transform: scale(1.1);
            //     }
            // }

            .list-box .title {
                color: #B7251E;
            }
        }

        .img-box {
            width: 100%;
            padding-bottom: 50%;
            overflow: hidden;
            position: relative;
            ::v-deep() {
                .image-slot{
                height: 100%;
            }
            }

            ::v-deep .el-image {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: auto;
                max-height: 100%;
                // transition: all 1s;
            }

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .list-box {
            padding: 16px;

            .title {
                color: rgb(25, 25, 25);
                font-size: 18px;
                font-weight: 400;
                line-height: 28px;
            }

            .desc {
                color: rgb(89, 89, 89);
                font-size: 14px;
                font-weight: 400;
                line-height: 22px;
                height: 22px;
                margin-top: 8px;
            }

            .date-box {
                padding-top: 4px;

                .le {
                    color: rgb(89, 89, 89);
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 18px;

                    span {
                        font-size: 14px;
                        margin-right: 5px;
                    }
                }

                .ri {
                    ::v-deep() {
                        .el-button {
                            border: none;
                            color: #1872FD;
                            min-width: 96px;
                            height: 36px;
                            border-radius: 20px;
                            background: rgb(231, 239, 255);
                            padding: 0 16px;
                        }
                    }

                    .end {
                        color: #6d7177;
                        background: #ffffff;
                        border: 1px solid #6d7177;
                    }
                }
            }
        }

        &:nth-child(3n) {
            margin-left: 20px;
        }

        &:nth-child(3n-1) {
            margin-left: 20px;
        }
    }
}

.pageing-box {
    padding-bottom: 138px;
}

/* 针对 2560px 及以下的屏幕 */
@media (max-width: 2560px) {
    .active-listcontent {
        .list {
            height: 430px;
        }
    }
}

/* 针对 1920px 及以下的屏幕 */
@media (max-width: 1920px) {
    .active-listcontent {
        .list {
            height: 430px;
        }
    }
}

/* 针对 1440px 及以下的屏幕 */
@media (max-width: 1440px) {
    .active-listcontent {
        .list {
            height: 333px;

            .img-box {
                height: 216px;
            }

            .list-box {
                padding: 8px 16px;

                .title {
                    line-height: 24px;
                }

                .desc {
                    height: 24px;
                    line-height: 24px;
                    margin-top: 3px;
                }

                .date-box {
                    .le {
                        line-height: 22px;
                    }
                }
            }
        }
    }

}
</style>